export default {
  title: 'Sprache',
  save_changes: 'Änderungen speichern',
};
